module.exports = __webpack_public_path__ + "img/channel-image.048a9fb5.svg";